module.exports = __webpack_public_path__ + "img/index-pic4.80dfbf90.webp";